import { motion } from "framer-motion";
import { Quote, ShieldCheck, Sprout, HeartHandshake } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.12 },
  }),
};

export const Mission = () => {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="py-24 md:py-32 bg-[#0b0d10]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          className="max-w-3xl"
        >
          <span className="inline-flex items-center gap-3 text-[#e2562a] uppercase tracking-[0.35em] text-xs font-bold mb-6">
            <span className="h-px w-10 bg-[#e2562a]" />
            Our Mission
          </span>
          <h2 className="font-display uppercase text-5xl md:text-6xl text-white tracking-tight leading-[0.95]">
            Fathers deserve <span className="text-[#e2562a]">support</span> too.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6 mt-14">
          <motion.div
            custom={0}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeUp}
            className="lg:col-span-7 bg-gradient-to-br from-[#16191e] to-[#0f1216] border border-white/10 text-white p-10 md:p-14 relative overflow-hidden"
          >
            <Quote className="h-12 w-12 text-[#e2562a] mb-6" />
            <p className="font-sans text-2xl md:text-3xl font-light leading-snug text-white/90">
              We believe fathers deserve support too, including safe outlets for
              emotional stress, personal growth, mental wellness, and healing
              while carrying the responsibilities of fatherhood.
            </p>
            <div className="absolute -bottom-12 -right-12 h-44 w-44 rounded-full bg-[#e2562a]/15 blur-3xl" />
          </motion.div>

          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-5 md:gap-6">
            {[
              {
                icon: HeartHandshake,
                title: "Emotional Support",
                text: "Safe spaces for stress, healing, and honest connection.",
              },
              {
                icon: Sprout,
                title: "Personal Growth",
                text: "Tools for mental wellness and becoming your best self.",
              },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                custom={i + 1}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={fadeUp}
                className="bg-[#16191e] border border-white/10 p-8 hover:border-[#e2562a]/50 transition-colors group"
              >
                <item.icon className="h-9 w-9 text-[#e2562a] mb-4" />
                <h3 className="font-display uppercase text-xl text-white mb-2 tracking-wide">
                  {item.title}
                </h3>
                <p className="text-white/55 leading-relaxed text-sm">
                  {item.text}
                </p>
              </motion.div>
            ))}
          </div>

          <motion.div
            custom={3}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeUp}
            className="lg:col-span-12 bg-[#16191e] border border-white/10 p-10 md:p-12 flex flex-col md:flex-row md:items-center gap-6"
          >
            <ShieldCheck className="h-10 w-10 text-[#e2562a] shrink-0" />
            <p className="text-lg md:text-xl text-white/80 leading-relaxed">
              DADication inspires fathers to build lasting legacies rooted in{" "}
              <span className="font-semibold text-white">love</span>,{" "}
              <span className="font-semibold text-white">leadership</span>,{" "}
              <span className="font-semibold text-white">accountability</span>,{" "}
              <span className="font-semibold text-white">protection</span>, and{" "}
              <span className="font-semibold text-white">dedication</span>.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
